import { FC, memo, useState } from "react";
import styled from "styled-components";
import { IWorkItem } from "../../../models/BlenderAgentStateModel";
import { dxpLayout } from "../../../style/theme";
import { getEnvSettings } from "../../../app/hostBasedSettings";
import { selectAuth } from "../../../redux/slices/authSlice";
import { message, notification } from 'antd';
import { useSelector } from 'react-redux';
import ChatFragment2 from '@buzzeasy/chat-fragment-2';

interface IProps {
  workItem: IWorkItem;
}

const RootContainer = styled.div`
  width: 100%;
  height: calc(100% - ${dxpLayout.workItemHeaderHeight});
`;

const ChatFragment: FC<IProps> = memo(({ workItem }) => {
  const [expanded, setExpanded] = useState(true);
  const envSettings = getEnvSettings();
  const apiBaseUrl = envSettings.apiBaseURL;
  const { token } = useSelector(selectAuth);
  
  return (
    <RootContainer>
     <ChatFragment2
        apiBaseUrl={apiBaseUrl}
        token={token}
        businessUnitId={workItem.businessUnitId || ''}
        notificationApi={notification}
        messageApi={message}
        onFocusRequested={() => console.log('onFocusRequested')}
        isFocused={true}
        expanded={expanded}
        onExpandedChangeRequested={(expanded: boolean) => setExpanded(expanded)}
        conversationId={workItem.primaryConversationId}
        theme={{ token: {} }}
     />
    </RootContainer>
  );
});

export default ChatFragment;
